import { render, staticRenderFns } from "./contrato-m-b.vue?vue&type=template&id=52a3ca88&lang=html&"
import script from "./contrato-m-b.vue?vue&type=script&lang=js&"
export * from "./contrato-m-b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports